<template>
  <!-- Loading Modal -->
  <div class="modal-messages" v-show="modal_message.showModalLoading">
    <div class="inside-modal-messages">
      <div class="row f-row text-center">
        <div
          class="col col-12"
          style="position: absolute; left: 0; top: 30%; z-index: 10000000;"
        >
          <span>{{ modal_message.messageModal }}</span>
          <br /><br />
          <span v-if="modal_message.optionsModal === false">
            <QSLoading
              :isLoading="modal_message.optionsModal === false"
              :size="45"
              :colorTheme="true"
          /></span>
          <!-- ============= Buttons =============  -->
          <div class="row f-row" v-if="modal_message.optionsModal === true">
            <div class="col col-12 text-center align-center ">
              <button @click="handlerAccept" class="btn btn-sm btn-home">
                Accept
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QSLoading from "@/components/QSLoading.vue";

export default {
  name: "Messages",
  components: { QSLoading },
  props: {
    modal_message: { required: true },
    colorTheme: { required: false, type: Boolean, default: true }
  },
  data() {
    return {
      logo_white: require("@/assets/images/logo_white.png"),
      logo_blue: require("@/assets/images/logo_blue.png"),
      logo: require("@/assets/images/logo_white.png")
    };
  },
  mounted() {
    if (this.colorTheme) {
      this.logo_white = require("@/assets/images/logo_white.png");
      this.logo = require("@/assets/images/logo_white.png");
    } else if (!this.colorTheme) {
      this.logo_white = require("@/assets/images/logo_black.png");
      this.logo = require("@/assets/images/logo_black.png");
    }
  },
  watch: {
    colorTheme() {
      if (this.colorTheme) {
        this.logo_white = require("@/assets/images/logo_white.png");
        this.logo = require("@/assets/images/logo_white.png");
      } else if (!this.colorTheme) {
        this.logo_white = require("@/assets/images/logo_black.png");
        this.logo = require("@/assets/images/logo_black.png");
      }
    }
  },
  methods: {
    handlerAccept() {
      this.modal_message.showModalLoading = !this.modal_message
        .showModalLoading;

      this.$emit("handlerAcceptModal");
    }
  }
};
</script>
